module.exports = __webpack_public_path__ + "static/media/gallery2.7b7e0dfa.png";